// Access のログイン画面や障害ページを、予算の JSON として解釈しない。
export class BudgetResponseError extends Error {
  constructor(message, needsPageReload = false) {
    super(message);
    this.needsPageReload = needsPageReload;
  }
}

export async function readBudgetResponse(response) {
  if (response.redirected || response.status === 401 || response.status === 403) {
    throw new BudgetResponseError('接続の認証を確認する必要があります。「接続を確認」を押してください。', true);
  }
  const type = response.headers.get('content-type') || '';
  if (!type.toLowerCase().includes('application/json')) {
    throw new BudgetResponseError('予算データではなく別の画面が返されました。「接続を確認」で再接続してください。', true);
  }
  let body;
  try {
    body = await response.json();
  } catch {
    throw new BudgetResponseError('予算データの応答を読み取れませんでした。再読み込みしてください。');
  }
  if (!response.ok || !body || !body.ok) {
    throw new BudgetResponseError(body?.error || `取得に失敗しました（HTTP ${response.status}）`);
  }
  return body;
}

export function validateBudgetSummary(body) {
  for (const period of ['monthly', 'annual']) {
    if (!body[period] || !['budget', 'actual', 'remain'].every(key => Number.isFinite(body[period][key]))) {
      throw new BudgetResponseError('予算データの形式が正しくありません。再読み込みしてください。');
    }
  }
  for (const info of [body.monthly, ...(Array.isArray(body.months) ? body.months : [])]) {
    if ((info.planned !== undefined || info.remainIncludingPlanned !== undefined)
      && (!Number.isFinite(info.planned) || !Number.isFinite(info.remainIncludingPlanned))) {
      throw new BudgetResponseError('未確定予定の形式が正しくありません。再読み込みしてください。');
    }
  }
  return body;
}
